import { jsx } from "react/jsx-runtime";
import { IconButton as MUIIconButton } from "@mui/material";
import { forwardRef, useCallback } from "react";
const IconButtonInner = ({ onMouseUp, ...restProps }, ref) => {
  const handleMouseUp = useCallback(
    (event) => {
      event.currentTarget.blur();
      onMouseUp?.(event);
    },
    [onMouseUp]
  );
  return /* @__PURE__ */ jsx(
    MUIIconButton,
    {
      onMouseUp: handleMouseUp,
      ...restProps,
      ref
    }
  );
};
const IconButton = forwardRef(IconButtonInner);
export {
  IconButton
};
